import styled from 'styled-components';
import colors from '@theme/colors';

export const Details = styled.pre`
  font-family: monospace;
  text-align: left;
  max-height: 200px;
  height: 200px;
  overflow-y: auto;
  background-color: ${colors.LIGHT_GREY};
  padding-bottom: 20px;
  margin: 0;
  box-shadow: inset 0px 4px 8px -4px rgba(0, 0, 0, 0.3),
    inset 0px -4px 8px -4px rgba(0, 0, 0, 0.3);
`;



// WEBPACK FOOTER //
// ./components/layout/ErrorBoundary.js